import { computed, action } from 'mobx';
import { IFundManager } from '../../../models/commonTypes';
import { StoreBase } from '../../../common/StoreBase';
import { IFundManagerCardConfiguration } from '../models';
import { QueryStore } from '../../App/stores/QueryStore';
import { StoreContext } from '../../../configuration/StoreContext';
import { IGridProps } from '@kurtosys/ksys-app-components/dist/components/base/Grid/models';
import { IGridComponentReference } from '@kurtosys/ksys-app-components/dist/components/base/Grid/models/IGridComponentReference';
import { Image } from '../../Image/Image';
import { ImageStore } from '../../Image/stores/ImageStore';
import { Name } from '../../Name/Name';
import { NameStore } from '../../Name/stores/NameStore';
import { Title } from '../../Title/Title';
import { TitleStore } from '../../Title/stores/TitleStore';
import { RedirectButton } from '../../RedirectButton/RedirectButton';
import { RedirectButtonStore } from '../../RedirectButton/stores/RedirectButtonStore';
import { Bio } from '../../Bio/Bio';
import { BioStore } from '../../Bio/stores/BioStore';
import { DefinitionList } from '../../DefinitionList/DefinitionList';
import { DefinitionListStore } from '../../DefinitionList/stores/DefinitionListStore';
import { Overlay } from '../../Overlay/Overlay';
import { OverlayStore } from '../../Overlay/stores/OverlayStore';
import { AssetImage } from '../../AssetImage/AssetImage';
import { AssetImageStore } from '../../AssetImage/stores/AssetImageStore';

export class FundManagerCardStore extends StoreBase {
	static componentKey: 'fundManagerCard' = 'fundManagerCard';
	queryStore: QueryStore;

	constructor(storeContext: StoreContext, fundManager: IFundManager) {
		super(storeContext);
		this.queryStore = new QueryStore(storeContext);
		this.loadQueryStoreContext(fundManager);
	}

	loadQueryStoreContext(fundManager: IFundManager) {
		this.queryStore.setFundManager(fundManager);
	}

	@computed
	get configuration(): IFundManagerCardConfiguration | undefined {
		if (this.storeContext && this.storeContext.appStore) {
			return this.storeContext.appStore.getComponentConfiguration(FundManagerCardStore.componentKey);
		}
	}

	@action
	async initialize(): Promise<void> {

	}

	@computed
	get stores() {
		return {
			image: new ImageStore(this.storeContext, this),
			title: new TitleStore(this.storeContext, this),
			name: new NameStore(this.storeContext, this),
			redirectButton: new RedirectButtonStore(this.storeContext, this),
			bio: new BioStore(this.storeContext, this),
			definitionList: new DefinitionListStore(this.storeContext, this),
			overlay: new OverlayStore(this.storeContext, this),
			assetImage: new AssetImageStore(this.storeContext, this),
		};
	}

	@computed
	get components(): { [key: string]: IGridComponentReference; } {
		return {
			'components.image': {
				key: 'components.image',
				component: Image,
				props: {
					imageStore: this.stores.image,
				},
			},
			'components.title': {
				key: 'components.title',
				component: Title,
				props: {
					titleStore: this.stores.title,
				},
			},
			'components.name': {
				key: 'components.name',
				component: Name,
				props: {
					nameStore: this.stores.name,
				},
			},
			'components.redirectButton': {
				key: 'components.redirectButton',
				component: RedirectButton,
				props: {
					redirectButtonStore: this.stores.redirectButton,
				},
			},
			'components.bio': {
				key: 'components.bio',
				component: Bio,
				props: {
					bioStore: this.stores.bio,
				},
			},
			'components.definitionList': {
				key: 'components.definitionList',
				component: DefinitionList,
				props: {
					definitionListStore: this.stores.definitionList,
				},
			},
			'components.overlay': {
				key: 'components.overlay',
				component: Overlay,
				props: {
					overlayStore: this.stores.overlay,
				},
			},
			'components.assetImage': {
				key: 'components.assetImage',
				component: AssetImage,
				props: {
					assetImageStore: this.stores.assetImage,
				},
			},
		};
	}

	@computed
	get gridProps(): IGridProps | undefined {
		const gridProps = this.configuration && this.configuration.gridProps;
		return gridProps;
	}
}